import { useState } from "react";
import { useViewport } from "src/common/hooks/ViewPort";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";

interface ModalProps {
  data: any; // 단일 food 객체
  setFoodInfo: (e: any) => void;
  onClose: () => void;
}

export const ModalFoodInfoFix = ({
  data,
  setFoodInfo,
  onClose,
}: ModalProps) => {
  const [name, setName] = useState(data.food.mealName || "새 음식");
  const [kcal, setKcal] = useState(data.food.calorie);

  const { px } = useViewport();

  const handleSave = () => {
    setFoodInfo((prev: any) =>
      prev.map((f: any, fIdx: number) =>
        fIdx === data.idx ? { ...f, mealName: name, calorie: kcal } : f
      )
    );
    onClose();
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "45rem",
        height: "100%",
        maxHeight: "100vh",
        position: "fixed",
        left: "50%",
        top: 0,
        transform: "translateX(-50%)",
        background: "#F9FAFB",
        zIndex: 999,
        padding: "0 16px",
      }}
    >
      {/* 헤더 */}
      <SubConHeader title="음식 정보 수정" onClickArrow={() => onClose()} />

      {/* 폼 카드 */}
      <div
        style={{
          marginTop: px(12),
          background: "#FFFFFF",
          borderRadius: px(14),
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
          padding: px(14),
        }}
      >
        <FieldRow
          label="음식명"
          control={
            <div style={{ position: "relative" }}>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                inputMode="text"
                style={editInputStyle(px)}
              />
              <span style={unitStyle(px)}></span>
            </div>
          }
          px={px}
        />

        <FieldRow
          label="칼로리"
          control={
            <div style={{ position: "relative" }}>
              <input
                value={kcal}
                onChange={(e) => setKcal(e.target.value)}
                inputMode="numeric"
                style={editInputStyle(px)}
              />
              <span style={unitStyle(px)}>Kcal</span>
            </div>
          }
          px={px}
        />
      </div>

      {/* 하단 저장 바 */}
      <div
        style={{
          width: "100%",
          maxWidth: "45rem",
          position: "fixed",
          left: "50%",
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          padding: px(16),
          background: "#fff",
          transform: "translateX(-50%)",
          borderTop: "1px rgba(0, 0, 0, 0.05) solid",
        }}
      >
        <div style={{ width: "100%" }}>
          <button
            onClick={handleSave}
            style={{
              width: "100%",
              height: px(50),
              background: "#F97316",
              color: "#fff",
              border: "none",
              borderRadius: px(10),
              fontSize: px(15),
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
            }}
          >
            수정하기
          </button>
        </div>
      </div>
    </div>
  );
};

const FieldRow: React.FC<{
  label: string;
  control: React.ReactNode;
  px: (n: number) => number;
}> = ({ label, control, px }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: `${px(90)}px 1fr`,
      alignItems: "center",
      gap: px(12),
      padding: `${px(8)}px 0`,
      //   borderBottom: `${px(1)}px solid #F3F4F6`,
    }}
  >
    <div style={{ fontSize: px(13), color: "#111827" }}>{label}</div>
    <div>{control}</div>
  </div>
);

const editInputStyle = (px: (n: number) => number): React.CSSProperties => ({
  width: "100%",
  height: px(48),
  borderRadius: px(12),
  border: `${px(1)}px solid #E5E7EB`,
  background: "#FFFFFF",
  color: "#111827",
  fontSize: px(14),
  padding: `0 ${px(40)}px 0 ${px(12)}px`, // 오른쪽 단위 공간 확보
  outline: "none",
});

const unitStyle = (px: (n: number) => number): React.CSSProperties => ({
  position: "absolute",
  right: px(12),
  top: "50%",
  transform: "translateY(-50%)",
  color: "#6B7280",
  fontSize: px(13),
});
